/**
 * Partners Slice
 *
 * Scrolling marquee of partner logos.
 */

import React from "react";
import { graphql } from "gatsby";

import BackgroundStaticVideo from "../../components/BackgroundStaticVideo";
import * as styles from "./Partners.module.scss";

export const Partners = ({ slice }) => {
  const { color_scheme, show_background_static_video } = slice?.primary || {};
  const items = slice?.items || [];

  // Duplicate items for seamless loop
  const marqueeItems = [...items, ...items];

  return (
    <section
      className={styles.partners}
      data-color-scheme={color_scheme || "black"}
      data-background-static-video={show_background_static_video ? "true" : undefined}
      id="partners"
    >
      {show_background_static_video && <BackgroundStaticVideo />}
      <div className={styles.marquee}>
        <div className={styles.marqueeTrack}>
          {marqueeItems.map((item, index) => {
            const Wrapper = item.link?.url ? "a" : "div";
            const wrapperProps = item.link?.url
              ? {
                  href: item.link.url,
                  target: item.link.target || "_blank",
                  rel: "noopener noreferrer",
                }
              : {};

            return (
              <Wrapper
                key={index}
                className={styles.logoItem}
                {...wrapperProps}
              >
                {item.logo?.url && (
                  <img
                    src={item.logo.url}
                    alt={item.name || "Partner logo"}
                    className={styles.logo}
                  />
                )}
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyPartners on PrismicHomepageDataBodyPartners {
    primary {
      color_scheme
      show_background_static_video
    }
    items {
      name
      logo {
        url
        alt
      }
      link {
        url
        target
      }
    }
  }
  fragment AboutPageDataBodyPartners on PrismicAboutPageDataBodyPartners {
    primary {
      color_scheme
      show_background_static_video
    }
    items {
      name
      logo {
        url
        alt
      }
      link {
        url
        target
      }
    }
  }
`;
